import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Modal, Spinner } from 'react-bootstrap';
import DegreeForm from '../components/forms/DegreeForm';
import DegreeTable from '../components/DegreeTable';

const DegreeEditModel = () => {
     const baseUrl = process.env.REACT_APP_BASE_URL;
     const navigate = useNavigate();
     const location = useLocation();
     const { id } = useParams();

     const [degreeData, setDegreeData] = useState(null);
     const [loading, setLoading] = useState(false);

     const showModal = location.pathname.startsWith('/degrees/edit');

     const handleCloseModal = () => {
          navigate('/degrees');
     };

     useEffect(() => {
          if (id && showModal) {
               setLoading(true);
               const token = localStorage.getItem('token');
               fetch(`${baseUrl}/getDegreeById/${id}`, {
                    headers: {
                         'Authorization': `Bearer ${token}`,
                         'Content-Type': 'application/json'
                    }
               })
                    .then(res => res.json())
                    .then(data => {
                         if (data.status) setDegreeData(data.data);
                         else setDegreeData(null);
                         setLoading(false);
                    })
                    .catch(() => setLoading(false));
          }
     }, [id, showModal, baseUrl]);

     return (
          <div>
               <DegreeTable />
               <Modal show={showModal} onHide={handleCloseModal} size="md" centered>
                    <Modal.Header closeButton>
                         <Modal.Title>Edit Degree</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                         {loading ? (
                              <div className="text-center">
                                   <Spinner animation="border" /> Loading...
                              </div>
                         ) : degreeData ? (
                              <DegreeForm degreeId={id} initialData={degreeData} />
                         ) : (
                              <p className="text-center">No data found for this Degree.</p>
                         )}
                    </Modal.Body>
               </Modal>
          </div>
     );
};

export default DegreeEditModel;